import type { FC, PropsWithChildren } from "react";
import { createContext, useMemo } from "react";

import { useCurrentBreakpoint } from "@ui/hooks/useCurrentBreakpoint";

import type { CarouselProps } from "../Carousel";
import { Carousel } from "../Carousel";

import styles from "./PushBlockContainer.module.scss";

export type PushBlockContainerContextType = {
  isCarousel: boolean;
};

export const PushBlockContainerContext = createContext<PushBlockContainerContextType>({
  isCarousel: false,
});

export interface PushBlockContainerProps extends CarouselProps {
  carouselDesktop?: boolean;
}

export const PushBlockContainer: FC<PropsWithChildren<PushBlockContainerProps>> = ({
  children,
  tabletItemCount = 2,
  desktopItemCount = 3,
  carouselDesktop = false,
  isAutoHeight = false,
}) => {
  const { mainBreakpoint, specificBreakpoint } = useCurrentBreakpoint();
  const isDesktop = ["lg", "md"].includes(mainBreakpoint);
  const isCarousel = carouselDesktop || !isDesktop;
  const isMobile = ["xSmall", "small", "smallMedium"].includes(specificBreakpoint);
  const value = useMemo(() => ({ isCarousel }), [isCarousel]);

  return (
    <div className={styles.content}>
      <PushBlockContainerContext.Provider value={value}>
        {isCarousel ? (
          <Carousel
            tabletItemCount={tabletItemCount}
            desktopItemCount={desktopItemCount}
            isAutoHeight={isAutoHeight}
            slidesPerView={isMobile ? 1.1 : 1}
            noBorderRadiusOnMobile={isMobile}
          >
            {children}
          </Carousel>
        ) : (
          <>{children}</>
        )}
      </PushBlockContainerContext.Provider>
    </div>
  );
};
